import React from 'react';

const Logo = ({ className = 'w-64 h-64' }) => {
  return (
    <svg viewBox="100 150 250 120" xmlns="http://www.w3.org/2000/svg" className={className} preserveAspectRatio="xMidYMid meet">
      {/* Logo Container */}
      <g transform="translate(200, 200)">
        {/* Icon: Stylized document with checkmarks/logs */}
        <g transform="translate(-80, -40)">
          {/* Document shape */}
          <rect x="0" y="0" width="70" height="90" rx="8" fill="#3b82f6" opacity="0.1"/>
          <rect x="0" y="0" width="70" height="90" rx="8" fill="none" stroke="#3b82f6" strokeWidth="3"/>

          {/* Log lines (horizontal bars) */}
          <line x1="12" y1="20" x2="40" y2="20" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round"/>
          <circle cx="48" cy="20" r="3" fill="#10b981"/>

          <line x1="12" y1="38" x2="40" y2="38" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round"/>
          <circle cx="48" cy="38" r="3" fill="#10b981"/>

          <line x1="12" y1="56" x2="40" y2="56" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round"/>
          <circle cx="48" cy="56" r="3" fill="#10b981"/>

          <line x1="12" y1="74" x2="30" y2="74" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" opacity="0.4"/>
        </g>

        {/* Text: Logio */}
        <text x="10" y="15" fontFamily="'Inter', 'Helvetica Neue', Arial, sans-serif" fontSize="48" fontWeight="700" fill="#1e293b" letterSpacing="-1">
          Logio
        </text>

        {/* Subtitle */}
        <text x="10" y="40" fontFamily="'Inter', 'Helvetica Neue', Arial, sans-serif" fontSize="14" fontWeight="400" fill="#64748b" letterSpacing="2">
          WORK LOGS
        </text>
      </g>

      {/* Accent dot on 'i' */}
      <circle cx="222" cy="172" r="4" fill="#10b981"/>
    </svg>
  );
};

export default Logo;

